<template>
    <div class="single-answer quesn-passage">
        <div class="passage">Passage</div>
        <div class="q-privew">
            <div class="q-type" :class="{ 'passage-font': !passageFont(currentQuestion) }"
                v-html="currentQuestion.passage"></div>
        </div>
        <div v-for="question in currentQuestion.childQuestions" :key="question.id">
            <SingleAnsQuePrivew :showAnswerField="showAnswerField" :currentQuestion="question"
            v-if="currentQuestion.subtype == QUE_TYPES.COMPREHENSION_2Q_SA || currentQuestion.subtype == QUE_TYPES.COMPREHENSION_3Q_SA || currentQuestion.subtype == QUE_TYPES.TC_2Q_SA || currentQuestion.subtype == QUE_TYPES.TC_3Q_SA || currentQuestion.subtype == QUE_TYPES.COMPREHENSION_2Q_MM" />

            <MultipleCorrectPrivew :showAnswerField="showAnswerField" :currentQuestion="question" v-if="
                question.subtype == QUE_TYPES.COMPREHENSION_2Q_MA ||
                question.subtype == QUE_TYPES.COMPREHENSION_3Q_MA
            " />
            <SubjectivePrivew :showAnswerField="showAnswerField" :isPreview="isPreview" :currentQuestion="question"
                v-if="question.subtype == QUE_TYPES.COMPREHENSION_2Q_NU" />
        </div>
        <div v-if="currentQuestion.solution && currentQuestion.isPreview">
            <h5 class="Solution">Solution:</h5>
            <div v-html="currentQuestion.solution"></div>
        </div>
    </div>
</template>
<script>
import SingleAnsQuePrivew from '@/components/PreviewTest/SingleAnsQuePrivew.vue';
import MultipleCorrectPrivew from '@/components/PreviewTest/MultipleCorrectPrivew.vue';
import SubjectivePrivew from '@/components/PreviewTest/SubjectivePrivew.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'ComprehensionMultiple',
    props: ['currentQuestion', 'showAnswerField', 'isPreview'],
    data() {
        return {};
    },
    computed: {
        ...mapGetters('testStore', ['isPastTest']),
    },
    components: {
        SingleAnsQuePrivew,
        MultipleCorrectPrivew,
        SubjectivePrivew,
    },
};
</script>